import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { adminColumnSharedFields } from '../../shared/columnDefinitions';

const getScenarioDescription = ({ periodName, scenarioName }) => `${periodName}_${scenarioName}`.replace(/ /g, '_');


export default ({
  columnDefinitions,
  baseScenario,
  compareScenario,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  const sheetData = [{
    name: 'Scenario Members',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      {
        field: 'groupDescription',
        headerName: 'Group',
      },
      ...columnDefinitions.filter(({ colId }) => colId !== adminColumnSharedFields.colId)
        .map(columnDef => columnDef.children
          ? columnDef.children.map(childColDef => ({
            ...childColDef,
            headerName: `${columnDef.headerName}\n ${childColDef.headerName}`,
          }))
          : columnDef
        )
        .flat(),
    ],
    data: entities,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  return xlsxExport({
    sheetData,
    metadata: {
      fileName: compareScenario
        ? `TLS_Scenario_Members_${getScenarioDescription(baseScenario)}_${getScenarioDescription(compareScenario)}_${environmentSuffix}`
        : `TLS_Scenario_Members_${getScenarioDescription(baseScenario)}_${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
